import * as React from 'react';
import initializeComponent from 'Shared/react-initialize';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { theme } from '@carpenter/theme';

const extendedTheme = extendTheme(theme);

export function Initializer(Component: any) {
   return (props: any) => (
      <ChakraProvider theme={extendedTheme} resetCSS={false}>
         <Component {...props} />
      </ChakraProvider>
   );
}

export function initializeChakraComponent(name: any, Component: any, defaultProps = {}) {
   initializeComponent(name, Initializer(Component), defaultProps);
}
